(() => {
  // Sections can load this asset repeatedly, including in the theme editor.
  if (window.__spotlightCardsBound) return;
  window.__spotlightCardsBound = true;

  const interactiveSelector = 'a, button, input, select, textarea, label, summary, [contenteditable]:not([contenteditable="false"]), [role="button"], [role="link"]';

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;

    const card = event.target.closest('.spotlight-card[data-spotlight-card-url]');
    if (!card || event.target.closest(interactiveSelector)) return;
    // Dragging to select card copy should never trigger navigation.
    if (window.getSelection()?.toString()) return;

    const url = card.getAttribute('data-spotlight-card-url');
    if (url) window.location.assign(url);
  });
})();
